import Vue from 'vue';
import Vuex from 'vuex';

import rootModule from './root_module';

Vue.use(Vuex);

export default new Vuex.Store(rootModule);
